export default __webpack_public_path__ + "static/media/HENNESSY_5.9f4b3261.gif";